import { configureStore } from '@reduxjs/toolkit'
import authReducer from "./slices/auth";
import messageReducer from "./slices/message";
import userReducer from "./slices/user";
import collectionReducer from "./slices/collection";
import signReducer from "./slices/sign"
import mqttReducer from "./slices/mqtt"
import signMessageReducer from "./slices/sign_message";
import signImageReducer from "./slices/sign_image";
import imageEditorReducer from "./slices/sign_image_editor";

const reducer = {
  auth: authReducer,
  message: messageReducer,
  user: userReducer,
  collection: collectionReducer,
  sign: signReducer,
  mqtt: mqttReducer,
  signMessage: signMessageReducer,
  signImage: signImageReducer,
  imageEditor: imageEditorReducer,
}


const store = configureStore({
  reducer: reducer,
  devTools: true,
})

export default store;